import { TooltipContent } from '@anm/components/Tooltip';
import Button from '@anm/components/buttons/Button';
import styled, { css } from 'styled-components';

import { TooltipContentProps } from '.';

const getPositionStyles = ({ tooltipDirection }: TooltipContentProps) =>
  ({
    'to-left': css`
      right: 0;
    `,
    'to-right': css`
      left: 0;
    `,
    center: css`
      right: 50%;
      transform: translateX(50%);
    `
  }[tooltipDirection]);

export const Wrapper = styled.div<TooltipContentProps>`
  text-align: center;

  ${TooltipContent} {
    padding: 20px 12px 24px;
    min-width: ${({ minWidth }) => minWidth}px;
    background: ${({ theme }) => theme.dropdownAndModalBg};
    box-shadow: 0 5px 20px rgba(1, 83, 130, 0.2);
    border-radius: 10px;
    right: unset;

    ${getPositionStyles};

    ${({ showToTop }) =>
      showToTop &&
      css`
        bottom: 100%;
      `};
  }
`;

export const TooltipText = styled.p`
  margin: 0 auto 16px;
  text-align: center;
  font-size: 14px;
  line-height: 22px;
  color: ${({ theme }) => theme.textColor};
`;

export const TooltipButton = styled(Button)`
  background: #30aef2;
  border-radius: 5px;
  margin: 0 auto;
  font-size: 14px;
  padding: 0 20px;
  min-width: 171px;
  color: #ffffff;
  height: 40px;
  line-height: 40px;
`;
